import { render, staticRenderFns } from "./UpdateKpis.vue?vue&type=template&id=50830bf3&"
import script from "./UpdateKpis.vue?vue&type=script&lang=js&"
export * from "./UpdateKpis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports